import { render, staticRenderFns } from "./v-header.vue?vue&type=template&id=6d514516&scoped=true&"
import script from "./v-header.vue?vue&type=script&lang=js&"
export * from "./v-header.vue?vue&type=script&lang=js&"
import style0 from "./v-header.vue?vue&type=style&index=0&id=6d514516&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d514516",
  null
  
)

export default component.exports